import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        // Delay showing banner to avoid CLS during initial page load
        setTimeout(() => {
            this.element.style.transform = 'translateY(0)';
            this.element.style.opacity = '1';
            this.element.style.pointerEvents = 'auto';
        }, 1000);
    }

    slideOut() {
        this.element.style.transform = 'translateY(100%)';
        this.element.style.opacity = '0';
        this.element.style.pointerEvents = 'none';

        // Remove element after animation completes
        setTimeout(() => {
            this.element.remove();
        }, 500);
    }
}